module.exports = __webpack_public_path__ + "static/img/exhibit-2.6f7e046.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutpic/exhibit-2.jpg
// module id = +x3I
// module chunks = 52